import { VideoCameraIcon } from '@heroicons/react/24/outline';
import { Button } from '../../../components/buttons/Button';
import { sentenceCase } from '../../../common/upperCaseWord';

export const LiveJoinBanner = ({ title, onJoin, asHost = false }) => {
    const heading = sentenceCase(
        title || (asHost ? 'Videollamada activa' : 'Clase en vivo disponible'),
    );

    return (
        <div
            className="live-join-banner"
            role="region"
            aria-label={asHost ? 'Videollamada activa' : 'Clase en vivo disponible'}
        >
            <div className="live-join-banner__copy">
                <span className="live-join-banner__live">
                    <span className="live-join-banner__dot" aria-hidden="true" />
                    En vivo
                </span>
                <div className="live-join-banner__text">
                    <p className="live-join-banner__title" title={heading}>
                        {heading}
                    </p>
                    <p className="live-join-banner__sub">
                        {asHost
                            ? 'Reanuda la videollamada como anfitrión'
                            : 'Únete para participar en tiempo real'}
                    </p>
                </div>
            </div>
            <Button
                type="button"
                variant="primary"
                size="sm"
                className="live-join-banner__cta"
                icon={<VideoCameraIcon className="w-4 h-4" aria-hidden="true" />}
                onClick={onJoin}
            >
                Unirse ahora
            </Button>
        </div>
    );
};
